import { useState } from "react";
import { api } from "@/lib/api";

const Btn = ({ onClick, children, testId, disabled }) => (
  <button disabled={disabled} onClick={onClick} data-testid={testId} className="rounded-full border border-[#444] px-3 py-1 text-[11px] font-bold text-white hover:border-[var(--accent)] hover:text-[var(--accent)] disabled:opacity-40">{children}</button>
);

export const Decide = ({ pid, r, onDone }) => {
  const [busy, setBusy] = useState(false);
  const [cust, setCust] = useState("");
  const [err, setErr] = useState(null);
  const call = async (path, body) => {
    setBusy(true); setErr(null);
    try { await api(`/admin/jobber-fixes/${pid}/rows/${r.row_id}/${path}`, { method: "POST", body }); onDone(); }
    catch (e) { setErr(e.message); } finally { setBusy(false); }
  };
  const go = (choice, value) => call("decide", { choice, value });
  if (r.decided) {
    const d = r.decided;
    return (
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <p className="text-[11px] text-[var(--accent)]" data-testid={`jf-decided-${r.row_id}`}>Decided: {d.choice === "keep" ? "kept as is" : d.choice === "accept" ? "suggestion applied" : d.label || d.value} · {d.by}{d.by_role === "franchisee" ? " (franchisee)" : ""}</p>
        <Btn disabled={busy} onClick={() => call("undo")} testId={`jf-undo-${r.row_id}`}>Undo</Btn>
        {err && <span className="text-[11px] text-[#EF4444]">{err}</span>}
      </div>
    );
  }
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2" data-testid={`jf-decide-${r.row_id}`}>
      {r.proposal_set && <Btn disabled={busy} onClick={() => go("accept")} testId={`jf-accept-${r.row_id}`}>{r.proposal_label}</Btn>}
      {(r.customer_options || []).length > 0 && <>
        <select value={cust} onChange={(e) => setCust(e.target.value)} data-testid={`jf-cust-select-${r.row_id}`} className="rounded-full border border-[#444] bg-[#121212] px-2 py-1 text-[11px] text-white">
          <option value="">Pick customer…</option>
          {r.customer_options.map((o) => <option key={o.id} value={o.id}>{o.name} · {o.id.slice(0, 6)}</option>)}
        </select>
        <Btn disabled={busy || !cust} onClick={() => go("customer", cust)} testId={`jf-cust-btn-${r.row_id}`}>Assign</Btn>
      </>}
      {(r.status_options || []).map((s) => <Btn key={s} disabled={busy} onClick={() => go("status", s)} testId={`jf-status-${s}-${r.row_id}`}>Mark {s.replace("_", " ")}</Btn>)}
      <Btn disabled={busy} onClick={() => go("keep")} testId={`jf-keep-${r.row_id}`}>Keep as is</Btn>
      {r.franchisee_review ? <span className="text-[11px] text-[#39A0FF]" data-testid={`jf-sent-${r.row_id}`}>Sent to franchisee</span>
        : <Btn disabled={busy} onClick={() => { const note = window.prompt("Message to the franchisee (shown with this item):", "Jobber and ALR don't match here. Please check your records, then use the fix or keep it as is."); if (note !== null) call("send", { note }); }} testId={`jf-send-${r.row_id}`}>Send to franchisee</Btn>}
      {err && <span className="text-[11px] text-[#EF4444]" data-testid={`jf-decide-err-${r.row_id}`}>{err}</span>}
    </div>
  );
};
